import React, { useState, useEffect } from 'react';
import { getEditPassword, setEditPassword, clearEditPassword } from '../services/auth';
import API_BASE from '../config';

const PasswordGate = ({ children, onUnlocked }) => {
  const [unlocked, setUnlocked] = useState(false);
  const [input, setInput] = useState('');
  const [error, setError] = useState('');
  const [checking, setChecking] = useState(false);

  useEffect(() => {
    const stored = getEditPassword();
    if (stored) {
      verify(stored);
    }
  }, []);

  useEffect(() => {
    if (unlocked && onUnlocked) onUnlocked();
  }, [unlocked, onUnlocked]);

  const verify = async (pwd) => {
    setChecking(true);
    setError('');
    try {
      const resp = await fetch(`${API_BASE}/auth/check`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Edit-Password': pwd },
      });
      if (resp.ok) {
        setEditPassword(pwd);
        setUnlocked(true);
      } else {
        clearEditPassword();
        setError('Incorrect password.');
        setUnlocked(false);
      }
    } catch {
      setError('Could not connect to server.');
    } finally {
      setChecking(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (input.trim()) verify(input.trim());
  };

  if (unlocked) return children;

  return (
    <div style={styles.overlay}>
      <div style={styles.box}>
        <h2 style={styles.title}>Edit Mode</h2>
        <p style={styles.sub}>Enter password to continue</p>
        <form onSubmit={handleSubmit}>
          <input
            style={styles.input}
            type="password"
            placeholder="Password"
            value={input}
            onChange={e => setInput(e.target.value)}
            autoFocus
          />
          {error && <p style={styles.error}>{error}</p>}
          <button style={styles.btn} type="submit" disabled={checking}>
            {checking ? 'Checking…' : 'Unlock'}
          </button>
        </form>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    minHeight: '60vh',
  },
  box: {
    background: 'white', borderRadius: 10, padding: '40px 48px',
    boxShadow: '0 4px 24px rgba(0,0,0,0.12)', textAlign: 'center', minWidth: 300,
  },
  title: { margin: '0 0 6px', color: '#2c3e50' },
  sub: { color: '#7f8c8d', marginBottom: 24, fontSize: 14 },
  input: {
    display: 'block', width: '100%', padding: '10px 14px', fontSize: 16,
    border: '1px solid #c0c8d2', borderRadius: 6, marginBottom: 12,
    boxSizing: 'border-box',
  },
  error: { color: '#e74c3c', fontSize: 13, margin: '-4px 0 10px' },
  btn: {
    width: '100%', padding: '10px', background: '#3498db', color: 'white',
    border: 'none', borderRadius: 6, fontSize: 15, fontWeight: 600, cursor: 'pointer',
  },
};

export default PasswordGate;
